<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="1250px">
      <validation-observer ref="observerDialog" v-slot="{ invalid }">
        <v-form @submit.prevent="doActionDialog">
          <v-card v-if="typeDialog == 1">
            <v-row>
              <v-container>
                <v-col lg="12" md="12" sm="12">
                  <v-banner
                    color="blue-grey lighten-5"
                    class="black--text"
                    shaped
                    single-line
                    align="left"
                  >
                    Reportar BI-RADS {{ model.idStudy }}
                  </v-banner>
                </v-col>
              </v-container>
              <v-col cols="6" lg="6" md="6" sm="12">
                <v-container>
                  <div>
                    <p>
                      Id Estudio:
                      <span class="font-weight-bold">{{ model.idStudy }}</span>
                    </p>
                    <p>
                      Paciente:
                      <span class="font-weight-bold">{{
                        model.fullNamePatient
                      }}</span>
                    </p>
                  </div>
                  <br />
                  <v-banner
                    color="blue-grey lighten-5"
                    class="mb-4 black--text"
                    shaped
                    single-line
                    align="left"
                  >
                    Reporte del estudio
                  </v-banner>
                  <v-card-text>
                    <v-row class="d-flex flex-column">
                      <v-col>
                        <validation-provider
                          v-slot="{ errors }"
                          name="BI-RADS"
                          rules="required"
                        >
                          <v-autocomplete
                            auto-select-first
                            :items="listBiradsFiltered"
                            v-model="modelDialog.birads"
                            :error-messages="errors"
                            no-data-text="Sin resultados"
                            label="BI-RADS*"
                            clearable dense
                            chips
                            item-value="value"
                            item-text="name"
                          >
                            <template
                              v-slot:selection="{ attr, on, item, selected }"
                            >
                              <v-chip
                                v-on="on"
                                v-bind="attr"
                                :input-value="selected"
                                :color="item.color"
                              >
                                <v-icon left>mdi-radioactive</v-icon>
                                <span v-text="item.name"></span>
                              </v-chip>
                            </template>
                          </v-autocomplete>
                        </validation-provider>
                      </v-col>
                      <v-col>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Nota adicional"
                        >
                          <v-textarea
                            v-model="modelDialog.note"
                            :error-messages="errors"
                            label="Nota adicional (opcional)"
                            clearable
                            autocomplete="off"
                            outlined
                          >
                          </v-textarea>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-container>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="12">
                <v-container>
                  <v-banner
                    color="blue-grey lighten-5"
                    class="mb-4 black--text"
                    shaped
                    single-line
                    align="left"
                  >
                    Hallazgos radiológicos
                  </v-banner>
                  <v-col
                    v-for="(listMastographyFinding,
                    index) in listMastographyFinding"
                    :key="index"
                    dense
                  >
                    <v-row>
                      <v-col cols="6" lg="6" md="6" sm="6" class="pa-0"
                        ><span class="d-flex align-center mt-5" align="center">
                          <strong>{{ listMastographyFinding.name }}:</strong
                          ><br /></span></v-col
                      ><v-col cols="3" lg="3" md="3" sm="3" class="pa-0"
                        ><v-checkbox
                          v-model="listMastographyFinding.idsFindingLocation"
                          :value="1"
                          label="Izquierda"
                        ></v-checkbox></v-col
                      ><v-col cols="3" lg="3" md="3" sm="3" class="pa-0"
                        ><v-checkbox
                          v-model="listMastographyFinding.idsFindingLocation"
                          :value="2"
                          label="derecha"
                        ></v-checkbox
                      ></v-col>
                    </v-row>
                  </v-col>
                </v-container>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12">
                <v-card-actions class="text-center">
                  <v-col>
                    <v-btn color="error" plain @click="resetFormCloseDialog()">
                      <v-icon left>mdi-chevron-left</v-icon> volver
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      type="submit"
                      :disabled="sending || invalid"
                      @click="updateFinding()"
                    >
                      {{ sending ? "Guardando..." : "Guardar" }}
                      <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </validation-observer>
      <v-card v-if="typeDialog != 1">
        <v-card-title>
          <h4 v-if="typeDialog == 2">Reportar estudio {{ model.idStudy }}</h4>
          <span v-if="typeDialog == 3">
            Cancelar estudio {{ model.idStudy }}
          </span>
          <!-- <h4 v-if="typeDialog == 4">Guardar plantilla</h4> -->
        </v-card-title>
        <v-container>
          <div v-if="typeDialog != 4">
            <p>
              Id Estudio:
              <span class="font-weight-bold">{{ model.idStudy }}</span>
            </p>
            <p>
              Paciente:
              <span class="font-weight-bold">{{ model.fullNamePatient }}</span>
            </p>
          </div>
          <validation-observer ref="observerDialog" v-slot="{ invalid }">
            <v-form @submit.prevent="doActionDialog">
              <v-card-text>
                <v-row v-if="typeDialog != 1 && typeDialog != 4">
                  <v-col
                    @click.right.prevent
                    @copy.prevent
                    @paste.prevent
                    ondrop="return false;"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="Razón"
                      rules="required|min:6"
                    >
                      <v-textarea
                        v-model="modelDialog.reason"
                        :error-messages="errors"
                        label="Razón*"
                        required
                        autocomplete="off"
                        outlined
                      >
                      </v-textarea>
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="text-center">
                <v-col>
                  <v-btn color="error" plain @click="resetFormCloseDialog()">
                    <v-icon left>mdi-chevron-left</v-icon> volver
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    color="primary"
                    type="submit"
                    :disabled="sending || invalid"
                  >
                    {{ sending ? "Guardando..." : "Guardar" }}
                    <v-icon right>mdi-content-save</v-icon>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { MastographyFindingService } from "@/app/services";
export default {
  props: {
    listBirads: Array,
    modelDialog: Object,
    model: Object,
    sending: Boolean,
    dialog: Boolean,
    typeDialog: Number,
    closeDialog: Function,
    doActionDialog: Function,
    action: Number,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      listMastographyFinding: [],
      listBiradsFiltered: []
    };
  },
  mounted() {
  

    this.modelDialog.note = null;
    this.modelDialog.birads = null;
    this.modelDialog.findingLocationTypeList = [];

    try{
      this.modelDialog.note = this.model.note;
      this.modelDialog.birads = this.model?.birads?.idBirads;
      this.modelDialog.findingLocationTypeList = this.model.findingLocationTypeList;
    }catch(e){
      console.log(e);
    }
    
    this.getMastographyFindings();
    this.filterBiradsList();

  },
  methods: {
    filterBiradsList(){
      this.listBiradsFiltered = [];
      const NA = 'NA';
      if(this.$utilFront.nonEmptyList(this.listBirads)){
        this.listBiradsFiltered = this.listBirads.filter((item)=> item.name != NA);
      }
    },
    getMastographyFindings() {
      this.listMastographyFinding = [];
      MastographyFindingService.listAll().then((res) => {
        let { data } = res;
        this.listMastographyFinding = data.map((data) => {
          return {
            name: data.name,
            idTypeFinding: data.idTypeFinding,
            idsFindingLocation: [],
          };
        });
        this.assignMastographyFindings();
      });
    },
    resetFormCloseDialog() {
      this.closeDialog();
    },
    updateFinding() {
      let withoutFinding = [];
      for (let v in this.listMastographyFinding) {
        if (this.listMastographyFinding[v].idsFindingLocation[0] != null) {
          withoutFinding.push(this.listMastographyFinding[v]);
        }
      }
      let beforeUpdateFinding = withoutFinding.map((data) => {
        return {
          idsFindingLocation: data.idsFindingLocation,
          idTypeFinding: data.idTypeFinding,
        };
      });
      this.modelDialog.findingLocationTypeList = beforeUpdateFinding;
    },

    assignMastographyFindings() {
      let foundit;
      // console.log(this.modelDialog.findingLocationTypeList);
      if (this.modelDialog.findingLocationTypeList != null) {
        this.modelDialog.findingLocationTypeList.map((data) => {
          foundit = this.listMastographyFinding.findIndex(
            (e) => e.idTypeFinding == data.idTypeFinding
          );
          this.listMastographyFinding[foundit].idsFindingLocation =
            data.idsFindingLocation;
        });
      }
    },
  },
};
</script>

<style></style>
